import { Types } from "assets/theme/base/typography";
import { HMO, HMOType } from "constants/hmo";

/**
 * HMO Typography Overrides
 * Defines typography customizations for each HMO portal
 * 
 * React 19 Best Practice: Pre-computed module-level constants
 * Since HMO is detected once and never changes, we pre-compute all possible values
 * This eliminates runtime computation and aligns with React 19's immutable patterns
 */

// Pre-computed HMO typography constants (React 19 best practice - compile-time constants)
const HMO_TYPOGRAPHY: Record<HMO, Partial<Types>> = {
  [HMO.LEUMIT]: {
    // Leumit-specific typography overrides can be added here
    // Example: fontSizeXXS: pxToRem(13), fontWeightBold: 800, etc.
  },

  [HMO.MACCABI]: {
    // Macabi-specific typography overrides can be added here
  },

  [HMO.CLALIT]: {
    // Clalit-specific typography overrides can be added here
  },

  [HMO.MEUCHEDET]: {
    // Meuchedet-specific typography overrides can be added here
  },
  [HMO.CLINICAL_TRIAL]: {
    // Trial-specific typography overrides can be added here
  },
};

// Default (no HMO) - empty object
const DEFAULT_TYPOGRAPHY: Partial<Types> = {};

/**
 * Returns HMO-specific typography overrides (React 19 best practice - O(1) lookup from pre-computed constants)
 * @param hmo - HMO identifier or null for default
 * @returns HMO typography overrides or empty object for default theme
 */
export function getHmoTypography(hmo: HMOType): Partial<Types> {
  if (!hmo) {
    return DEFAULT_TYPOGRAPHY;
  }
  
  return HMO_TYPOGRAPHY[hmo] || DEFAULT_TYPOGRAPHY;
}












